export default __webpack_public_path__ + "images/logo-black_bc656a.svg";